import { render, staticRenderFns } from "./MedicineCost.vue?vue&type=template&id=d2243050"
import script from "./MedicineCost.vue?vue&type=script&lang=js"
export * from "./MedicineCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports